<template>
  <div>
    <TitleContainer :title="'運営事務局からのお知らせメール設定'" :isExtraWidth="false"/>
    <div class="profile-info-block" v-if="Object.keys(profile).length !== 0">
      <div class="profile-info">
        <p>
          新たに登録可能となった企業や、各社の採用情報等
        </p>
        <div class="d-flex flex-row">
          <div class="dropdown-container">
            <select
              v-model="dropdownValue"
              @change="changeMassEmailStatus"
              class="custom-dropdown"
            >
              <option value="receive">受け取る</option>
              <option value="do-not-receive">受け取らない</option>
            </select>
            <span class="dropdown-icon">
              <i class="fas fa-chevron-down"></i>
            </span>
          </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Api from '@/config/api';
import TitleContainer
 from './TitleContainer.vue';
export default {
  components: {
    TitleContainer
  },
  data() {
    return {
      dropdownValue: '',
    };
  },
  computed: {
    ...mapGetters({
      profile: 'getProfile',
    }),
    checkMassEmailStatus() {
      return this.profile.mass_email;
    },
  },
  methods: {
    ...mapActions({
      setProfile: 'setProfile',
    }),
    sliderClass() {
      if (this.checkMassEmailStatus) {
        return 'slider round active';
      }
      return 'slider round';
    },
    async changeMassEmailStatus() {
      try {
        const token = await this.$auth.getToken();
        const data = {
          massEmailStatus: !this.checkMassEmailStatus,
        };
        const response = await this.axios({
          method: 'put',
          data,
          url: Api.url(Api.endpoints.changeEmailStatus),
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        this.profile.mass_email = response.data.data.mass_email;
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
      this.dropdownValue = this.checkMassEmailStatus
        ? 'receive'
        : 'do-not-receive';
  },
  watch: {
    'profile': {
      immediate: true,
      handler(newProfile, oldProfile) {
        this.dropdownValue = this.checkMassEmailStatus ? 'receive' : 'do-not-receive';
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
p {
  color: #787878
}
.form-wrap {
  margin-bottom: 30px;
}
.rg-title {
  font-weight: 700;
  font-size: 21px;
}

.dropdown-container {
  position: relative;
}
.dropdown-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
}
.custom-dropdown {
  /* Remove default styles */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Set custom styles */
  background-color: #f0f0f0;
  border: none;
  padding: 10px;
  border-radius: 5px;
  font-size: 14px;
  color: #000000;
  padding-right: 30px;
}

.custom-dropdown:focus {
  outline: none;
  box-shadow: 0 0 2px #888888;
}

.custom-dropdown option {
  background-color: #ffffff;
  color: #000000;
}
.custom-dropdown option:selected {
  font-weight: bold;
}
.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 14px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.38);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  right: 50%;
  top: -4px;
  background-color: #f5f5f5;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.active {
  background-color: #7db4b4;
}
.slider.active::before {
  left: 50%;
  background-color: #006c6b;
}

input:checked + .slider {
  background-color: #7db4b4;
}

input:focus + .slider {
  box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
@media (max-width: 550px) {
  .rg-title {
    font-weight: 700;
    font-size: 17px;
  }
}
</style>
